/* import { optionsFilter } from '../../filters';

export default (table) => {
  let name = 'promotion_job_name';
  let options = optionsFilter;
  let defaultValue = (value, data) => data.job_name;

  switch (table) {
    case 'editCompensation':
      name = 'request.promotion_job_name';
  
      options = (column, config, data) => {optionsFilter(column, config, data.request);}
      defaultValue = (value, data) => data.request.for.job_name;
      break;
    default:
      break;
  }

  let property = {
    type: "string",
    inputType: "select",
    name,
    label: "New Job",
    section: "Promotion",
    visible: true,
    editable: true,
    options,
    defaultValue
  }

  if(table == "internalHire"){
    property.width = "10%";
  }

  return property;
}; */
import { optionsFilter } from '../../filters';

export default (table) => {
  let name = 'promotion_job_name';
  let options = optionsFilter;
  let defaultValue = (value, data) => data.job_name;

  switch (table) {
    case 'editCompensation':
      case 'editInternalHire':
      name = 'request.promotion_job_name';
      options = (column, config, data) => optionsFilter(column, config, data.request);
      defaultValue = (value, data) => data.request.for.job_name;
      break;
    default:
      break;
  }

  return {
    type: "string",
    inputType: "select",
    name,
    label: "New Job",
    section: "Promotion",
    visible: true,
    editable: true,
    options,
    defaultValue,
    width : "10%"
  };
};